var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2655_27813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16623 9.95095H9.45095V4.66623H16.6662V10.4857H18.0551V4.66623C18.0551 4.29788 17.9088 3.94461 17.6483 3.68414C17.3879 3.42367 17.0346 3.27734 16.6662 3.27734H7.54818L2.77734 8.04818V21.3329C2.77734 21.7013 2.92367 22.0545 3.18414 22.315C3.44461 22.5755 3.79788 22.7218 4.16623 22.7218H16.6662C17.0346 22.7218 17.3879 22.5755 17.6483 22.315C17.9088 22.0545 18.0551 21.7013 18.0551 21.3329H4.16623V9.95095ZM4.16623 8.61762L8.11762 4.66623H8.3329V8.8329H4.16623V8.61762Z",
    fill: "#004B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 11.8545C19.5339 11.7407 19.363 11.6813 19.1883 11.688C19.0135 11.6948 18.8477 11.7672 18.724 11.8909C18.6003 12.0146 18.5279 12.1804 18.5211 12.3551C18.5144 12.5299 18.5738 12.7008 18.6876 12.8337L20.9446 15.0837H12.5001C12.3159 15.0837 12.1393 15.1568 12.0091 15.287C11.8788 15.4173 11.8057 15.5939 11.8057 15.7781C11.8057 15.9623 11.8788 16.1389 12.0091 16.2691C12.1393 16.3994 12.3159 16.4725 12.5001 16.4725H20.9654L18.6876 18.7503C18.6149 18.8126 18.5559 18.8892 18.5142 18.9753C18.4725 19.0615 18.4491 19.1553 18.4454 19.251C18.4417 19.3466 18.4578 19.442 18.4927 19.5311C18.5276 19.6202 18.5806 19.7011 18.6483 19.7688C18.7159 19.8365 18.7969 19.8895 18.886 19.9244C18.9751 19.9593 19.0705 19.9754 19.1661 19.9717C19.2618 19.968 19.3556 19.9446 19.4418 19.9029C19.5279 19.8612 19.6045 19.8022 19.6668 19.7295L23.6112 15.7781L19.6668 11.8545Z",
    fill: "#004B2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2655_27813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.74efdb1787a5566dea76214d40a9c7ca.svg";
export { ForwardRef as ReactComponent };